import { getCustomerData, fetchOrderRecommendationData } from "@ocm/services/services.recommendationData";
import pushDataLayer from "@ocm/services/dataLayer";
import { trackGA4Purchase } from "@ocm/services/analytics4Tracking";
import GA4ItemListService from "@ocm/services/services.ga4ItemList";

const init = async () => {
	if (!(document.documentElement.classList.contains("is-checkout") && document.querySelector(".global-e-wrapper"))) {
		return;
	}

	try {
		await waitForGlobalE();
	} catch (error) {
		console.error(error.message);
		return;
	}

	// see https://docs.global-e.com/enterprise/en/client-analytics.html#oncheckoutsteploaded-203102
	window.glegem?.("OnCheckoutStepLoaded", (data) => {
		if (!data || !data.Steps || data.StepId !== data.Steps.CONFIRMATION) return;

		if (data.IsSuccess && !data.IsPageReload) handleCheckoutConfirmation();
	});
};

const TIMEOUT_DURATION = 8100;
const POLLING_FREQUENCY = 300;

const waitForGlobalE = () => {
	const timeout = Date.now() + TIMEOUT_DURATION;

	return new Promise((resolve, reject) => {
		const check = () => {
			if (window.glegem) {
				return resolve();
			}

			if (Date.now() >= timeout) {
				return reject(new Error("Global-e was not available within the timeout."));
			}

			window.setTimeout(check, POLLING_FREQUENCY);
		};
		check();
	});
};

const handleCheckoutConfirmation = async () => {
	try {
		const { Recommendation } = await getOrderData();

		pushDataLayer({ event: "virtualPageView", Recommendation });
		if (Recommendation.orderData) trackGA4Purchase(Recommendation.orderData);
	} catch (error) {
		console.error(error.message);
	} finally {
		GA4ItemListService.clear();
	}
};

const getOrderData = async () => {
	const cartCode = getCustomerData().cart?.code;
	if (!cartCode) {
		throw new Error("Cart code is missing in recommendation data.");
	}

	return await fetchOrderDataWithRetry(cartCode);
};

const isPendingOrderDataError = (error) => {
	const statusCode = error?.response?.status ?? error?.status;

	return statusCode === 404;
};

const fetchOrderDataWithRetry = async (cartCode) => {
	const timeout = Date.now() + TIMEOUT_DURATION;

	while (Date.now() < timeout) {
		try {
			return await fetchOrderRecommendationData(cartCode);
		} catch (error) {
			if (!isPendingOrderDataError(error)) {
				throw error;
			}

			if (Date.now() + POLLING_FREQUENCY >= timeout) {
				throw new Error("Order recommendation data was not available within the timeout.", { cause: error });
			}

			await new Promise((resolve) => window.setTimeout(resolve, POLLING_FREQUENCY));
		}
	}
};

export { init };
